export class MessageHead {
	persnr: number;
	unread_messages: number;
	unarchived_messages: number;
	last_message_date: string;
}
